import { ModelDataType } from 'src/app/interfaces/model-data-type';

import { BaseModel } from './base-model';
import { CompanyRanking } from './company-ranking';

export class ClientRegisteredVendorFee extends BaseModel {
  static ClientRegisteredVendorFeeProperties: (
    | {
        property: keyof ClientRegisteredVendorFee;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof ClientRegisteredVendorFee;
        type: 'alias';
      }
    | {
        property: keyof ClientRegisteredVendorFee;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'CompanyId', type: 'column', dataType: 'number' },
    { property: 'feeType', type: 'column', dataType: 'string' },
    { property: 'feeAmt', type: 'column', dataType: 'number' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' }
  ];

  static {
    ClientRegisteredVendorFee.ClientRegisteredVendorFeeProperties.forEach(
      (propertyObject) => {
        const { property, type } = propertyObject;
        if (type === 'column') {
          ClientRegisteredVendorFee.columnMap.set(property, propertyObject);
        }
        if (type === 'alias') {
          ClientRegisteredVendorFee.aliasedColumnMap.set(
            property,
            propertyObject as { property: string; type: 'alias' }
          );
        }
        if (type === 'association') {
          ClientRegisteredVendorFee.associationMap.set(
            property,
            propertyObject as {
              property: string;
              type: 'association';
              model: string;
            }
          );
        }
      }
    );
  }

  constructor(
    ClientRegisteredVendorFeeObject: Partial<ClientRegisteredVendorFee>
  ) {
    super();

    ClientRegisteredVendorFee.ClientRegisteredVendorFeeProperties.forEach(
      (propertyObject) => {
        const { property } = propertyObject;
        const value = ClientRegisteredVendorFeeObject[property];
        if (value !== undefined) {
          Object.assign(this, { [property]: value });
        }
      }
    );
  }

  id?: number;
  CompanyId?: number;
  feeAmt?: number;
  feeType?:
    'STANDARD' | 'TINCHECK ONLY' | 'IRS TIN MATCH' | 'CORPORATE FILING REPORT';
  createdAt?: Date;
  updatedAt?: Date;
}
